// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__wqo9C","loader":"Loader_loader__+lRPl","loader-inner":"Loader_loader-inner__WK65p"};